import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel, TableRow } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { TrackingLogEntry, TrackingLogAggRow, LoginFailedLeaderRow, NavLeaderboardRow } from 'app/stores/admin.log.store';
import { FindSteart } from 'app/models/core/steart.model';
import { formatDateLong, formatDateLongWithWeekday, formatNum } from 'app/utils';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { init, EChartsOption, ECharts } from 'echarts';
import { debounce } from 'lodash';
import colors from 'assets/scss/colors.module.scss';


export const AdminLogInfo = () => {
	return <>
		<ul>
			<li>Tracking Fitness Pdfs ab 25.2.2025</li>
			<li>Tracking Pdf Generierung ab 19.1.2025. Vollständig ab 28.2.2025</li>
			<li>Tracking Send (email) ab 6.3.2025</li>
			<li>Tracking mit aktueller VD/GS/Name/Steart ab 6.3.2026</li>
			<li>Tracking von Navigation ab 19.3.2026</li>
		</ul>
	</>
}

export const AdminLogList = observer(() => {
	const { adminLogStore } = useStore();

	const reload = () => {
		adminLogStore.reset();
		adminLogStore.load();
	};

	const tm = new TableModel<TrackingLogEntry, string>();
	let cols: ITableColumn<TrackingLogEntry, string>[] = [
		{
			label: 'BnrId',
			path: 'bnr_id',
		},
		{
			label: 'bensl',
			path: 'bensl',
		},
		{
			label: 'Datum',
			path: 'action_date',
			render: (row: TableRow<TrackingLogEntry>) => {
				return <>{formatDateLong(new Date(row.data.action_date))}</>;
			},
		},
		{
			label: 'Action',
			path: 'action',
		},
		{
			label: 'Name',
			path: 'name',
		},
		{
			label: 'Steart',
			path: 'steart',
			render: (row: TableRow<TrackingLogEntry>) => {
				const s = FindSteart(row.data.steart);
				return <>{s.name} [{row.data.steart}]</>;
			},
		},
		{
			label: 'VD',
			path: 'vd',
		},
		{
			label: 'GS',
			path: 'gs',
		},
	];

	tm.setCols(cols);
	tm.sortBy = 'action_date';
	tm.sortAsc = false;
	tm.idProperty = 'id';

	useEffect(() => {
		adminLogStore.load();
	}, [adminLogStore, adminLogStore.filterKey]);

	useEffect(() => {
		if (adminLogStore.loaded) {
			tm.setRowData(adminLogStore.items);
		}
	}, [adminLogStore.loaded, adminLogStore.items]);

	return (
		<>
			<div>
				Anzahl Zeilen: {adminLogStore.items.length}
				<button className="button is-small" style={{ marginLeft: '0.5rem' }} onClick={reload}>Aktualisieren</button>
			</div>
			<Table tm={tm} stickyFooter={true} />
		</>
	);
});

const aggCols: ITableColumn<TrackingLogAggRow, string>[] = [
	{ label: 'Logins', path: 'logins', agg: [{ aggType: AggregrationType.sum }] },
	{ label: 'Login Fehler', path: 'login_fails', agg: [{ aggType: AggregrationType.sum }] },
	{ label: 'Passwort vergessen', path: 'forgot_password', agg: [{ aggType: AggregrationType.sum }] },
	{ label: 'Fitness Pdf', path: 'fitness_pdf', agg: [{ aggType: AggregrationType.sum }] },
	{ label: 'Fitness Pdf Fehler', path: 'fitness_pdf_error', agg: [{ aggType: AggregrationType.sum }] },
	{ label: 'Pdfs', path: 'pdf_gen', agg: [{ aggType: AggregrationType.sum }] },
	{ label: 'Pdf Fehler', path: 'pdf_error', agg: [{ aggType: AggregrationType.sum }] },
	{ label: 'Send', path: 'send_count', agg: [{ aggType: AggregrationType.sum }] },
	{ label: 'Nav', path: 'nav_count', agg: [{ aggType: AggregrationType.sum }] },
];

export const AdminLogByDay = observer(() => {
	const { adminLogStore } = useStore();

	const tm = new TableModel<TrackingLogAggRow, string>();
	let cols: ITableColumn<TrackingLogAggRow, string>[] = [
		{
			label: 'Datum',
			path: 'period',
			render: (row: TableRow<TrackingLogAggRow>) => {
				return <>{formatDateLongWithWeekday(moment(row.data.period).toDate())}</>;
			},
		},
		...aggCols,
	];

	tm.setCols(cols);
	tm.sortBy = 'period';
	tm.sortAsc = false;
	tm.idProperty = 'period';

	useEffect(() => {
		adminLogStore.loadByDay();
	}, [adminLogStore, adminLogStore.filterKey]);

	useEffect(() => {
		if (adminLogStore.byDayLoaded) {
			tm.setRowData(adminLogStore.byDay);
		}
	}, [adminLogStore.byDayLoaded, adminLogStore.byDay]);

	return (
		<>
			<div>Anzahl Zeilen: {adminLogStore.byDay.length}</div>
			<Table tm={tm} stickyFooter={true} />
		</>
	);
});

export const AdminLogByMonth = observer(() => {
	const { adminLogStore } = useStore();

	const tm = new TableModel<TrackingLogAggRow, string>();
	let cols: ITableColumn<TrackingLogAggRow, string>[] = [
		{
			label: 'Monat',
			path: 'period',
		},
		...aggCols,
	];

	tm.setCols(cols);
	tm.sortBy = 'period';
	tm.sortAsc = false;
	tm.idProperty = 'period';

	useEffect(() => {
		adminLogStore.loadByMonth();
	}, [adminLogStore, adminLogStore.filterKey]);

	useEffect(() => {
		if (adminLogStore.byMonthLoaded) {
			tm.setRowData(adminLogStore.byMonth);
		}
	}, [adminLogStore.byMonthLoaded, adminLogStore.byMonth]);

	return (
		<>
			<div>Anzahl Zeilen: {adminLogStore.byMonth.length}</div>
			<Table tm={tm} stickyFooter={true} />
		</>
	);
});

const getBarColor = (value: number, avg: number, upperLimit: number, lowerLimit: number): string => {
	if (value < lowerLimit || value > upperLimit) return '#dc3545';
	const deviation = Math.abs(value - avg) / avg;
	if (deviation > 0.2) return '#fd7e14';
	return '#28a745';
};

interface IAdminLogByHourEChartProps {
	chartData: { period: string; hour: string; total: number }[];
	avg: number;
	upperLimit: number;
	lowerLimit: number;
	onBarClick: (period: string) => void;
}

const AdminLogByHourEChart = observer((props: IAdminLogByHourEChartProps) => {
	const { uiStore } = useStore();
	const { chartData, avg, upperLimit, lowerLimit, onBarClick } = props;
	const chartRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!chartData || chartData.length === 0) return;

		// Build x-axis data with custom labels (only show day labels at 00:00)
		const xAxisData: string[] = [];
		const xAxisLabels: { [key: number]: string } = {};

		chartData.forEach((d, index) => {
			xAxisData.push(d.hour);
			if (d.hour.endsWith('00:00')) {
				const dayLabel = d.hour.split(' ')[0];
				const weekday = moment(dayLabel, 'DD.MM').format('dd')[0].toUpperCase();
				xAxisLabels[index] = `${weekday} ${dayLabel}`;
			}
		});

		// Build series data with colors
		const seriesData = chartData.map((d, index) => {
			const color = getBarColor(d.total, avg, upperLimit, lowerLimit);
			const isLast = index === chartData.length - 1;

			return {
				value: d.total,
				itemStyle: {
					color: color,
					borderColor: isLast ? '#000' : 'transparent',
					borderWidth: isLast ? 2 : 0,
				},
			};
		});

		const option: EChartsOption = {
			tooltip: {
				trigger: 'axis',
				formatter: (params: any) => {
					if (Array.isArray(params) && params[0]) {
						const p = params[0];
						return `Stunde: ${p.name}<br/>${formatNum(p.value)} Actions`;
					}
					return '';
				},
			},
			xAxis: {
				type: 'category',
				data: xAxisData,
				axisLabel: {
					fontSize: 10,
					interval: 0,
					formatter: (value: string, index: number) => {
						return xAxisLabels[index] || '';
					},
				},
				axisTick: {
					alignWithLabel: true,
				},
			},
			yAxis: {
				type: 'value',
				axisLabel: {
					fontSize: 10,
					formatter: (value: number) => formatNum(value),
				},
			},
			series: [
				{
					type: 'bar',
					data: seriesData,
					markLine: {
						data: [
							{
								yAxis: Math.round(avg),
								label: {
									formatter: 'Avg',
									fontSize: 10,
									color: colors.grey,
								},
								lineStyle: {
									color: colors.grey,
									type: [3, 3],
								},
							},
							{
								yAxis: upperLimit,
								label: {
									formatter: '+2σ',
									fontSize: 10,
									color: '#dc3545',
								},
								lineStyle: {
									color: '#dc3545',
									type: [5, 5],
								},
							},
							{
								yAxis: lowerLimit,
								label: {
									formatter: '-2σ',
									fontSize: 10,
									color: '#dc3545',
								},
								lineStyle: {
									color: '#dc3545',
									type: [5, 5],
								},
							},
						],
						symbol: 'none',
					},
				},
			],
			grid: {
				left: '40px',
				right: '20px',
				top: '20px',
				bottom: '40px',
			},
			animation: !uiStore.printMode,
		};

		let chart: ECharts | null = null;
		if (chartRef.current) {
			chart = init(chartRef.current, null, { renderer: 'svg' });
			chart.setOption(option);

			// Add click handler
			chart.on('click', (params: any) => {
				if (params.componentType === 'series' && params.dataIndex !== undefined) {
					const clickedData = chartData[params.dataIndex];
					onBarClick(clickedData.period);
				}
			});
		}

		const handleResize = debounce(() => {
			chart?.resize();
		}, 300);
		window.addEventListener('resize', handleResize);

		return () => {
			chart?.dispose();
			window.removeEventListener('resize', handleResize);
		};
	}, [chartData, avg, upperLimit, lowerLimit, onBarClick, uiStore.printMode]);

	return <div ref={chartRef} style={{ width: '100%', height: 300 }} />;
});

export const AdminLogByHour = observer(() => {
	const { adminLogStore } = useStore();
	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		adminLogStore.loadByHour();
	}, [adminLogStore, adminLogStore.filterKey]);

	const handleBarClick = (period: string) => {
		// period format: "YYYY-MM-DD HH"
		const [date, hour] = period.split(' ');
		const p = new URLSearchParams(location.search);
		p.set('dateFrom', `${date}T${hour}:00`);
		p.set('dateTo', `${date}T${hour}:59`);
		p.set('view', 'log');
		history.replace({ search: p.toString() });
	};

	const data = adminLogStore.byHour;

	// Build lookup from existing data: period -> total
	const dataByPeriod = new Map<string, number>();
	for (const row of data) {
		const total = Number(row.logins || 0) + Number(row.login_fails || 0) + Number(row.forgot_password || 0)
			+ Number(row.fitness_pdf || 0) + Number(row.fitness_pdf_error || 0)
			+ Number(row.pdf_gen || 0) + Number(row.pdf_error || 0) + Number(row.send_count || 0)
			+ Number(row.nav_count || 0);
		dataByPeriod.set(row.period, total);
	}

	// Generate all 168 hourly slots (7 days × 24 hours)
	const chartData: { period: string; hour: string; total: number }[] = [];
	const now = moment().startOf('hour');
	const start = moment(now).subtract(7, 'days');
	const cursor = moment(start);
	while (cursor.isSameOrBefore(now)) {
		const period = cursor.format('YYYY-MM-DD HH');
		const label = cursor.format('DD.MM HH:00');
		chartData.push({
			period,
			hour: label,
			total: dataByPeriod.get(period) || 0,
		});
		cursor.add(1, 'hour');
	}

	const values = chartData.map((d) => d.total);
	const avg = values.length > 0 ? values.reduce((s, v) => s + v, 0) / values.length : 0;
	const stdDev = values.length > 0 ? Math.sqrt(values.reduce((s, v) => s + Math.pow(v - avg, 2), 0) / values.length) : 0;
	const upperLimit = Math.round(avg + 2 * stdDev);
	const lowerLimit = Math.round(Math.max(0, avg - 2 * stdDev));

	if (!adminLogStore.byHourLoaded) return <p>Lade Chart...</p>;
	if (chartData.length === 0) return <p>Keine Daten</p>;

	return (
		<div className="control-chart">
			<div className="chart-stats" style={{ display: 'flex', gap: '1.5rem', fontSize: '0.85rem', marginTop: '0.5rem', color: '#666' }}>
				<span><strong>Aktuell:</strong> {formatNum(chartData[chartData.length - 1]?.total ?? 0)}</span>
				<span><strong>Avg:</strong> {formatNum(Math.round(avg))}</span>
				<span><strong>+2σ:</strong> {formatNum(upperLimit)}</span>
				<span><strong>-2σ:</strong> {formatNum(lowerLimit)}</span>
			</div>
			<AdminLogByHourEChart
				chartData={chartData}
				avg={avg}
				upperLimit={upperLimit}
				lowerLimit={lowerLimit}
				onBarClick={handleBarClick}
			/>
		</div>
	);
});

export const AdminLogNavLeaderboard = observer(() => {
	const { adminLogStore } = useStore();

	const tm = new TableModel<NavLeaderboardRow, string>();
	const cols: ITableColumn<NavLeaderboardRow, string>[] = [
		{
			label: 'Seite',
			path: 'nav_clean',
		},
		{
			label: 'Aufrufe',
			path: 'nav_count',
			agg: [{ aggType: AggregrationType.sum }],
		},
	];

	tm.setCols(cols);
	tm.sortBy = 'nav_count';
	tm.sortAsc = false;
	tm.idProperty = 'nav_clean';

	useEffect(() => {
		adminLogStore.loadNavLeaderboard();
	}, [adminLogStore, adminLogStore.filterKey]);

	useEffect(() => {
		if (adminLogStore.navLeaderboardLoaded) {
			tm.setRowData(adminLogStore.navLeaderboard);
		}
	}, [adminLogStore.navLeaderboardLoaded, adminLogStore.navLeaderboard]);

	return (
		<>
			<div>Top {adminLogStore.navLeaderboard.length} meistbesuchte Seiten</div>
			<Table tm={tm} stickyFooter={true} />
		</>
	);
});

export const AdminLogLoginFailedLeaderboard = observer(() => {
	const { adminLogStore } = useStore();

	const tm = new TableModel<LoginFailedLeaderRow, string>();
	const cols: ITableColumn<LoginFailedLeaderRow, string>[] = [
		{
			label: 'Bensl',
			path: 'bensl',
		},
		{
			label: 'Name',
			path: 'name',
		},
		{
			label: 'VD',
			path: 'vd',
		},
		{
			label: 'Login Fehler',
			path: 'login_fails',
			agg: [{ aggType: AggregrationType.sum }],
		},
	];

	tm.setCols(cols);
	tm.sortBy = 'login_fails';
	tm.sortAsc = false;
	tm.idProperty = 'bensl';

	useEffect(() => {
		adminLogStore.loadLeaderboard();
	}, [adminLogStore, adminLogStore.filterKey]);

	useEffect(() => {
		if (adminLogStore.leaderboardLoaded) {
			tm.setRowData(adminLogStore.loginFailedLeaderboard);
		}
	}, [adminLogStore.leaderboardLoaded, adminLogStore.loginFailedLeaderboard]);

	return (
		<>
			<div>Top {adminLogStore.loginFailedLeaderboard.length} Benutzer mit den meisten fehlgeschlagenen Login-Versuchen</div>
			<Table tm={tm} stickyFooter={true} />
		</>
	);
});
